module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "about-view"
    }
  }, [_c('div', {
    attrs: {
      "id": "wideContent"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "boxContent"
  }, [_c('div', {
    staticClass: "photo200"
  }, [_c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/about/01.jpg'),
      "rel": "group",
      "title": "Vchod do salonu"
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/about/02.jpg'),
      "rel": "group",
      "title": "Střihací stůl"
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/about/03.jpg'),
      "rel": "group",
      "title": "Koupací koutek"
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/about/04.jpg'),
      "rel": "group",
      "title": "Kikinka"
    }
  }, [_vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/about/05.jpg'),
      "rel": "group",
      "title": "Sára"
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/about/06.jpg'),
      "rel": "group",
      "title": "Maxík"
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/about/07.jpg'),
      "rel": "group",
      "title": "Kačenka"
    }
  }, [_vm._m(8)])]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "boxContent"
  }, [_c('h1', [_vm._v("O nás")]), _vm._v(" "), _c('p', [_vm._v("\n          Salon Jája je psí salon, který se v první řadě stará o\n          zkrášlování vašich domácích mazlíčků. Stejně tak se ale\n          snažíme i o zajištění jejich co největšího pohodlí, ke\n          kterému přispívá útulné prostředí našeho salonu. Ten zároveň\n          slouží i jako kamenný obchod, kde poskytujeme prodej\n          kosmetiky a potřeb pro pejsky a kočičky. Do budoucna\n          zvažujeme i rozšíření obchodu do formy e-shopu.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          S chovem a péčí o pejsky máme letité zkušenosti, jež\n          potvrzují i naši mazlíci, jimiž jsou tři pudličky a kocour.\n          Od roku 1996 vlastníme chovnou stanici, kde se od roku 2006\n          věnujeme chovu malých plemen, především pudl trpasličí a\n          toy.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Lepší představu o nás a našem salonu Vám nabídne\n          fotogalerie níže, protože jak je známo jeden obrázek řekne\n          víc než tisíc slov.\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boxTitle"
  }, [_c('h2', [_vm._v("Fotogalerie")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/about/thumb_01.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/about/thumb_02.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/about/thumb_03.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/about/thumb_04.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/about/thumb_05.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/about/thumb_06.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/about/thumb_07.jpg"),
      "width": "200"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6316b9b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AboutView.vue
// module id = 79
// module chunks = 0